'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/breadcrumb/style/css.js
// module id = 254
// module chunks = 0